import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _DarkTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { DarkTheme5_3 } from "../DarkTheme5_3";
import { themeTokens5_4 } from "../consts";
export var DarkTheme5_4 = createTheme({
  themeClass: (_DarkTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function DarkTheme5_4() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(DarkTheme5_4, _BasicThemeClassForEx);
    return DarkTheme5_4;
  }(BasicThemeClassForExtension), _DarkTheme5_.textareaMargin = themeTokens5_4.textareaMargin, _DarkTheme5_.clearCrossIconWidthSmall = themeTokens5_4.clearCrossIconWidthSmall, _DarkTheme5_.clearCrossIconWidthMedium = themeTokens5_4.clearCrossIconWidthMedium, _DarkTheme5_.clearCrossIconWidthLarge = themeTokens5_4.clearCrossIconWidthLarge, _DarkTheme5_.clearCrossIconAlign = themeTokens5_4.clearCrossIconAlign, _DarkTheme5_.textareaVerticalAlign = themeTokens5_4.textareaVerticalAlign, _DarkTheme5_),
  prototypeTheme: DarkTheme5_3,
  themeMarkers: [markThemeVersion('5.4')]
});